// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"0c273c34","631":"52e7762a"}[chunkId] + ".chunk.js";
};